<template>
	<div>
		<v-expansion-panels v-model="panel" flat accordion>
			<ExpansionPanel :title="'Basics'">
				<div>Checkout client secret</div>
				<CombinedInputFieldDataMenu class="mb-6" :textAreaMode="true" :value.sync="clientSecret" :valuesTypes="dataInputMenuValueTypes" />
				<div>Publishable key</div>
				<CombinedInputFieldDataMenu class="mb-6" :textAreaMode="true" :value.sync="stripeKey" :valuesTypes="dataInputMenuValueTypes" />
			</ExpansionPanel>
			<ExpansionPanel :title="'Advanced'">
				<div class="pt-2">Confirmation Handling:</div>
				<AppSelect
					:items="STRIPE_SETTINGS_CONFIRMATION_OPTIONS"
					outlined
					dense
					placeholder="Automatically proceed to next step with animation"
					item-text="title"
					item-value="value"
					v-model="confirmationHandlingOption"
				></AppSelect>
			</ExpansionPanel>
		</v-expansion-panels>
		<div class="info-box">
			Map the checkout client secret from the Stripe action "Create mini-app checkout". Get the publishable key from your Stripe dashboard.
		</div>
	</div>
</template>

<script>
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import { STRIPE_SETTINGS_CONFIRMATION_OPTIONS } from '../stripe-mini-app.const';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';

export default {
	name: 'StripeFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		ExpansionPanel,
		CombinedInputFieldDataMenu,
	},
	computed: {
		metadataOptions() {
			return this.localField.metadata.options;
		},
		confirmationHandlingOption: {
			get() {
				return this.metadataOptions.confirmation_handling_option.value;
			},
			set(newValue) {
				this.setLocalFieldKey('metadata.options.confirmation_handling_option.value', newValue);
			},
		},
		clientSecret: {
			get() {
				return this.metadataOptions.client_secret.value;
			},
			set(newValue) {
				this.setLocalFieldKey('metadata.options.client_secret.value', newValue);
			},
		},
		stripeKey: {
			get() {
				return this.metadataOptions.stripe_key.value;
			},
			set(newValue) {
				this.setLocalFieldKey('metadata.options.stripe_key.value', newValue);
			},
		},
	},
	data() {
		return { STRIPE_SETTINGS_CONFIRMATION_OPTIONS };
	},
	methods: {},
};
</script>

<style scoped>
div > .info-box {
	font-size: 12px;
	color: #646e87;
	background-color: #f9fafc;
	padding: 10px;
	border-radius: 5px;
	margin-top: 20px;
}
</style>
